import { Checkbox, Table, TableProps } from 'antd';
import NoData from 'components/noData/noData';

import { ModifiedPermission } from 'modules/roles/models/modifiedPermission';
import { useTranslation } from 'react-i18next';

interface permissionsProps {
	permissions: ModifiedPermission[];
	onPermissionChange: any;
}

function ModulesPermissionsComponent({ permissions, onPermissionChange }: permissionsProps) {
	const { t } = useTranslation();

	const columns: TableProps<ModifiedPermission>['columns'] = [
		{
			title: t('ROLES.MODULE'),
			dataIndex: 'name',
			key: 'name',
			fixed: 'left',
			render: (name) => <span style={{ textWrap: 'nowrap' }}>{t(`ROLES.${name.toUpperCase()}`)}</span>,
		},
		{
			title: t('COMMON.VIEW'),
			dataIndex: 'view',
			key: 'view',
			render: (view) =>
				view.id ? <Checkbox id={view.id} defaultChecked={view.value} onChange={() => onPermissionChange(view.id)} /> : null,
		},
		{
			title:  t('COMMON.CREATE'),
			dataIndex: 'create',
			key: 'create',
			render: (create) =>
				create.id ? <Checkbox id={create.id} defaultChecked={create.value} onChange={() => onPermissionChange(create.id)} /> : null,
		},
		{
			title:  t('COMMON.UPDATE'),
			dataIndex: 'update',
			key: 'update',
			render: (update) =>
				update.id ? <Checkbox id={update.id} defaultChecked={update.value} onChange={() => onPermissionChange(update.id)} /> : null,
		},
		{
			title:  t('COMMON.DELETE'),
			dataIndex: 'delete',
			key: 'delete',
			render: (deleted) =>
				deleted.id ? <Checkbox id={deleted.id} defaultChecked={deleted.value} onChange={() => onPermissionChange(deleted.id)} /> : null,
		},
	];

	return <Table columns={columns} rowKey={'key'} dataSource={permissions} pagination={false} scroll={{ x: 500 }}
	locale={{ emptyText: <NoData /> }}
	/>;
}

export default ModulesPermissionsComponent;
